export const TabItemVariant = {
  TAB: 'tab',
  RADIO: 'radio',
} as const;

export type TabItemVariantType =
  (typeof TabItemVariant)[keyof typeof TabItemVariant];

export type TabItemProps = {
  label: string;
  active: boolean;
  focusable?: boolean;
  variant?: TabItemVariantType;
  tabId?: string;
  ariaControls?: string;
  testId?: string;
};
